// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xsJbf","newExpiryDate":"styles_newExpiryDate__3HU7C","footer":"styles_footer__1YKFI"};